export enum RouteKeys {
  List = '/payout',
  Details = '/payout/:id',
}
